export const secondsToHHMMSS = (time: number) => new Date(time * 1000).toISOString().slice(11, 19);
